import { blue, grey } from '@mui/material/colors';
import {
	$danger,
	$warning,
	$success,
	$dangerLight,
	$dangerDark,
	$warningLight,
	$warningDark,
	$successLight,
	$successDark,
	$white,
	$black
} from 'constants/styles/_colors';
import GraphikRegFont from 'assets/fonts/Graphik-Regular-Web.woff2';

export const lightThemeConfig = {
	colorSchemes: {
		light: true
	},
	palette: {
		primary: blue,
		secondary: grey,
		error: {
			main: $danger,
			light: $dangerLight,
			dark: $dangerDark,
			contrastText: $white
		},
		warning: {
			main: $warning,
			light: $warningLight,
			dark: $warningDark,
			contrastText: $black
		},
		success: {
			main: $success,
			light: $successLight,
			dark: $successDark,
			contrastText: $black
		}
	},
	typography: {
		useNextVariants: true,
		suppressDeprecationWarnings: true,
		fontFamily: [
			'Graphik',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"'
		].join(',')
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: `
					@font-face {
						font-family: 'Graphik';
						font-size: 0.875rem;
						font-style: normal;
						font-display: swap;
						src: local('Graphik'), local('Graphik-Regular-Web'), url(${GraphikRegFont}) format('woff2');
						unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;

					}
				`
		},
		MuiLink: {
			defaultProps: {
				underline: 'hover'
			}
		},
		MuiTabPanel: {
			styleOverrides: {
				root: {
					padding: '0px'
				}
			}
		}
	}
};
